import { BACKEND_URL } from "./config/environment";

// Backend URL is resolved per environment in src/config/environment.js - do not hardcode it here.
export const base_url = BACKEND_URL;

export const redirect_social_login_url =
  window.location.hostname === "localhost" ? "http://localhost:3000/" : "";
export const setUrl = () => {
  sessionStorage.setItem("prev_url", window.location.href);
};
export const ADMIN_ROLE = 1;

export const BUSINESS_ROLE = 2;
export const INVESTOR_ROLE = 3;
export const SUPER_ADMIN_ROLE = 5;
export const AUDITOR_ROLE = 4;
//service request types::
export const SERVICE_REQUEST_NEW_LOAN = 0;
export const SERVICE_REQUEST_EXTEND_TENURE = 1;
export const SERVICE_REQUEST_PRE_CLOSURE = 2;
export const SERVICE_REQUEST_PARTIAL_PRE_PAYMENT =  3;

export const STATUS_NEW = 1;
export const STATUS_IN_PROGRESS = 2;
export const STATUS_APPROVED = 3;
export const STATUS_REJECTED = 4;
export const STATUS_PROCESSED = 5;
export const STATUS_CLOSED = 6;
export const LOAN_REPAYMENT_BY_BUSINESS = 7;
export const LOAN_DELISTED = 8;
export const LOAN_TECHNICAL_CLOSURE = 9;
export const STATUS_PENDING_INVESTOR = 10; 
//loan currency types
export const LOAN_CURRENCY_TYPE_BHD = "BHD";
export const LOAN_CURRENCY_TYPE_USD = "USD";
export const CURRENCY_EXCHANGE_WITH_DINAR = 2.659;
//rakings
export const RATING_A = 1;
export const RATING_B = 2;
export const RATING_C = 3;
export const RATING_D = 4;

//crypto key
export const CRYPTO_SECRET_KEY = "8DQ1DABA8A4EE292A832E4C5BB7WC";

export const COMPLIANCE_NEW = 0;
export const COMPLIANCE_PENDING = 1;
export const COMPLIANCE_APPROVED = 2;
export const COMPLIANCE_REJECTED = 3;


//business history actions
export const ACTION_TYPE_BUSINESS_CREATION = 1;
export const ACTION_TYPE_KYC_DOCUMENTS = 2;
export const ACTION_TYPE_SERVICE_REQUEST = 3;
export const ACTION_TYPE_LOAN_REPAYMENT = 4;
export const ACTION_TYPE_APPROVED = 5;
export const ACTION_TYPE_PAYMENT_TO_BUSINESS = 6;


//Notifications
export const NOTIFICATION_TYPE_KYC_SUBMITTED = 21;
export const NOTIFICATION_TYPE_KYC_APPROVED = 22;
export const NOTIFICATION_TYPE_KYC_REJECTED = 23;
export const NOTIFICATION_ENTITY_BUSINESS = "Business";
export const NOTIFICATION_ENTITY_INVESTOR = "Investor";
export const NOTIFICATION_ENTITY_ADMIN = "Admin";
export const NOTIFICATION_ENTITY_ALLINVESTORS = "AllInvestors";
export const NOTIFICATION_TYPE_COMPLIANCE = 1;
export const NOTIFICATION_TYPE_RENEW_DOCUMENT = 2;
export const NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION = 3;
export const NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY = 4;
export const NOTIFICATION_TYPE_INTEREST_SUBMITTED = 5;
export const NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR = 6;
export const NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE = 7;
export const NOTIFICATION_TYPE_PAYMENT_PROCESSED = 8;
export const NOTIFICATION_TYPE_LOAN_CLOSED = 9;
export const NOTIFICATION_TYPE_EXTEND_TENURE_REQUEST = 10;
export const NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED = 11;
export const NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED = 12;
export const NOTIFICATION_TYPE_PRE_CLOSURE_REQUEST = 13;
export const NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED = 14;
export const NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED = 15;
export const NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS = 16;
export const NOTIFICATION_TYPE_NEW_LOAN_REJECTED = 17;


export const COUNTRY = "bahrain";


export const NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REQUEST  = 18;
export const NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED  = 19;
export const NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED  = 20;

export const NOTIFICATION_TYPE_LOAN_DELISTED = 24;
export const NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE = 25;

//kyc form investor
export const INVESTOR_TYPE_INDIVIDUAL= "individual";
export const INVESTOR_TYPE_COMPANY = "institution";

// REACT_APP_TURNSTILE_SITEKEY lets a local automated run (QA, demo recording) use Cloudflare's
// always-pass test key; it is never set for real builds, so the defaults below stay in force.
export const TURNSTILE_SITEKEY  = process.env.REACT_APP_TURNSTILE_SITEKEY || (window.location.hostname==="localhost"?"0x4AAAAAAAZb1Qaxlo1ivPqg": "0x4AAAAAAAZLTlQv2_dact5K");
export const RANDOM_NUMBER = Math.random()

//save
export const SAVE_CONSTANT=1;
export const SUBMIT_CONSTANT=0;

export const LOAN_WAIVER_APPLIED = 11

// --- Multiple Investors (Fund Now) ---
// InvestorRequests (opportunity) statuses. NOTE: 11 collides numerically with LOAN_WAIVER_APPLIED
// above — only ever compare these against an OPPORTUNITY status field.
export const OPPORTUNITY_STATUS_OPEN = 1;
export const OPPORTUNITY_STATUS_FULLY_FUNDED = 11;
export const OPPORTUNITY_STATUS_DISBURSING = 12;
export const OPPORTUNITY_STATUS_PROCESSED = 5;

export const SUBSCRIPTION_STATUS_ACTIVE = 1;
export const SUBSCRIPTION_STATUS_WITHDRAWN = 2;

export const WITHDRAWAL_STATUS_NONE = 0;
export const WITHDRAWAL_STATUS_REQUESTED = 1;
export const WITHDRAWAL_STATUS_APPROVED = 2;
export const WITHDRAWAL_STATUS_REJECTED = 3;
export const WITHDRAWAL_WINDOW_DAYS = 5;

// Fund Now: minimum BHD 100, only in multiples of BHD 100 (mirrors the backend's funding-math.js).
export const MINIMUM_INVESTMENT_AMOUNT_BHD = 100;
export const INVESTMENT_STEP_AMOUNT_BHD = 100;

export const NOTIFICATION_TYPE_WITHDRAWAL_REQUEST = 29;
export const NOTIFICATION_TYPE_WITHDRAWAL_APPROVED = 30;
export const NOTIFICATION_TYPE_WITHDRAWAL_REJECTED = 31;
export const NOTIFICATION_TYPE_FUNDING_80_PERCENT = 32;
export const NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED = 33;
export const NOTIFICATION_TYPE_INVESTMENT_ADJUSTED = 34;
export const NOTIFICATION_TYPE_LOAN_DISBURSED = 35;
export const NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY = 36;
export const NOTIFICATION_TYPE_EXTENSION_INVESTOR_APPROVED = 27;
export const NOTIFICATION_TYPE_EXTENSION_INVESTOR_REJECTED = 28;
// "Funding closed at 97%; loan amount is now BHD 1,261" (D7).
export const fundingClosedText = (n) =>
  `Funding for loan ${n.reference_number} was closed at ${n.funded_percent}%. The loan amount is now ${n.loan_currency === LOAN_CURRENCY_TYPE_USD ? "$" : "BHD"}\u00A0${Number(n.loan_amount || 0).toLocaleString()}`;

// Mirrors the backend's currency convention: exchange rate = USD per 1 BHD.
export const convertCurrency = (amount, from, to, rate) => {
  const n = Number(amount) || 0;
  if (from === to) return n;
  if (from === LOAN_CURRENCY_TYPE_BHD && to === LOAN_CURRENCY_TYPE_USD) return n * Number(rate);
  if (from === LOAN_CURRENCY_TYPE_USD && to === LOAN_CURRENCY_TYPE_BHD) return n / Number(rate);
  return n;
};

// Non-breaking space between symbol and number so "$ 4,000.00" never wraps across lines.
export const formatMoney = (amount, currency) =>
  `${currency === LOAN_CURRENCY_TYPE_USD ? "$\u00A0" : "BHD\u00A0"}${Number(amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// USD loans use the BHD figure converted and rounded to a whole dollar (BHD 100 at 2.65 -> $265),
// exactly like the backend, so both sides agree on the minimum and the step.
const toInvestmentUnits = (amountBhd, currency, rate) =>
  currency === LOAN_CURRENCY_TYPE_USD ? Math.round(amountBhd * Number(rate)) : amountBhd;
export const getInvestmentMinimum = (currency, rate) => toInvestmentUnits(MINIMUM_INVESTMENT_AMOUNT_BHD, currency, rate);
export const getInvestmentStep = (currency, rate) => toInvestmentUnits(INVESTMENT_STEP_AMOUNT_BHD, currency, rate);

// "BHD 100" / "$ 265" — no forced decimals, for rule copy.
export const formatInvestmentAmount = (amount, currency) =>
  `${currency === LOAN_CURRENCY_TYPE_USD ? "$" : "BHD"}\u00A0${Number(amount || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

const toCents = (n) => Math.round(Number(n) * 100);

// Same rules as the backend's validateFundNowAmount (funding-math.js), so the investor sees the
// exact error before submitting. The backend remains the authority. Every pledge (including a
// repeat pledge on the same loan) must be >= the minimum and a multiple of the step, except a
// pledge of exactly the remaining amount.
export const validateFundNowAmount = ({ amount, currency, remaining, availableBalance, rate }) => {
  const min = getInvestmentMinimum(currency, rate);
  const step = getInvestmentStep(currency, rate);
  const effectiveMin = remaining > 0 ? Math.min(min, remaining) : min;
  const amt = Number(amount);
  if (!amount || !(amt > 0)) return { ok: false, message: "" };
  const isExactRemainder = remaining > 0 && toCents(amt) === toCents(remaining);
  if (amt < effectiveMin) return { ok: false, message: `Please enter a value of minimum ${formatInvestmentAmount(effectiveMin, currency)}.` };
  if (!isExactRemainder && step > 0 && toCents(amt) % toCents(step) !== 0) {
    const orRemainder = remaining > 0 && toCents(remaining) % toCents(step) !== 0
      ? ` (or exactly the remaining ${formatInvestmentAmount(remaining, currency)})`
      : "";
    return { ok: false, message: `Investments must be in multiples of ${formatInvestmentAmount(step, currency)}${orRemainder}.` };
  }
  if (amt > availableBalance) return { ok: false, message: `Exceeds your available balance (${formatMoney(availableBalance, currency)}).` };
  if (amt > remaining) return { ok: false, message: `Only ${formatMoney(remaining, currency)} left to fund this opportunity.` };
  return { ok: true, message: "Looks good." };
};

// Loan History (D8): records that carry their own description (generic loan events, waivers,
// closure) are shown as-is. Admin screens see names; borrower and investor screens see the
// public wording without investor names.
export const loanEventMessage = (record, { admin = false } = {}) =>
  (admin ? record.description : record.public_description || record.description) || "";

// QA #32: Loan History lists are shown newest first.
export const sortLoanHistory = (items) =>
  [...(items || [])].sort((a, b) => Number(new Date(b.created_date_time)) - Number(new Date(a.created_date_time)));
